import { Component, inject } from '@angular/core';
import { AlertType } from '../alert/alert';
import { map, Observable } from 'rxjs';
import { UserProfileStore } from '../../states/user-profile/user-profile.store';
import { NotificationHubService } from '../../services/notification/notification-hub.service';
import { Notification } from '../../models/notification/notificaiton.model';

@Component({
  selector: 'app-notification-panel',
  standalone: false,
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss',
})
export class NotificationPanelComponent {
  readonly notificationHubService = inject(NotificationHubService);
  readonly userProfileStore = inject(UserProfileStore);

  notifications$: Observable<Notification[]>;

  constructor() {
    this.notifications$ = this.notificationHubService.notifications$;
  }

  unreadCount(): Observable<number | null> {
    return this.notificationHubService.notifications$.pipe(
      map(notifs => notifs.filter(n => !n.isRead).length)
    ).pipe(map(count => count > 0 ? count : null));
  }

  clearAll(): void {
    this.notificationHubService.clearAll();
  }

  markAsRead(notificationId: string): void {
    this.notificationHubService.markAsRead(notificationId);
  }

  markAllRead(): void {
    this.notificationHubService.markAllRead();
  }

  iconFor(type: AlertType): string {
    return {
      success: 'pi pi-check-circle',
      error: 'pi pi-times-circle',
      warning: 'pi pi-exclamation-triangle',
      info: 'pi pi-info-circle',
    }[type];
  }

  iconColorFor(type: AlertType): string {
    return {
      success: '#22C55E',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#3B82F6',
    }[type];
  }
}
